import { useParams } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../hooks/app";
import { useEffect, useState } from "react";
import { StatusEnum } from "../../../commons/enums/status-enum";
import { AppBox, AppContainer, AppModal, NotFound } from "../../../commons/components";
import { cleanUpUserInfo, fetchUser } from "../../../redux/slices/user/manage-user-slice";
import UserManageDetailHeader from "./components/UserManageDetailHeader";
import { setPageTitle } from "../../../redux/slices/page-title-slice";
import IconEdit from "../../../commons/components/icons/edit";
import { cleanUpStepperFormData } from "../../../redux/slices/stepper-form-slice";
import UserAddEdit from "./components/userAddEdit/UserAddEdit";
import UserInfo from "./components/UserInfo";
import { User } from "../../../commons/models/user";
import { updateUser } from "../../../redux/slices/session-slice";

export default function UserDetailManage() {
  const { userId } = useParams();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.session);
  const [isEditUser, setIsEditUser] = useState(false);
  const { userInfo, userInfoStatus } = useAppSelector((state) => state.manageUser);
  const { userEditResponseStatus } = useAppSelector((state) => state.manageUserEdit);
  useEffect(() => {
    dispatch(fetchUser(Number(userId)));
  }, [userId]);

  useEffect(() => {
    if (userInfoStatus === StatusEnum.Failed) {
      return () => {
        dispatch(cleanUpUserInfo());
      };
    }
  }, [userInfoStatus]);

  useEffect(() => {
    dispatch(setPageTitle(""));
    return () => {
      dispatch(cleanUpUserInfo());
    };
  }, []);

  useEffect(() => {
    if (user && userInfo && user.id === userInfo.id) {
      Object.assign(userInfo, {
        avatar: user.avatar,
        fullName: user.fullName,
        firstName: user.firstName,
        lastName: user.lastName,
        middleName: user.middleName,
      });
    }
  }, [user]);

  const handleAfterEdit = (updatedUser?: User) => {
    setIsEditUser(false);
    if (updatedUser) {
      dispatch(updateUser(updatedUser));
    }
    dispatch(fetchUser(Number(userId)));
  };

  const handleAfterEditClose = () => {
    setIsEditUser(false);
    dispatch(cleanUpStepperFormData());
  };

  return (
    <AppContainer>
      {userInfoStatus === StatusEnum.Failed ? (
        <NotFound />
      ) : (
        <AppBox mt="md" flexDirection="column" gap="md">
          <UserManageDetailHeader user={userInfo} onEditUser={() => setIsEditUser(true)} />
          <UserInfo userInfo={userInfo} />
        </AppBox>
      )}
      <AppModal
        opened={isEditUser}
        modalSize="lg"
        onClose={handleAfterEditClose}
        title="Edit User"
        titleIcon={<IconEdit />}
        withoutButtons
        withLoadingButton={userEditResponseStatus === StatusEnum.Loading}
      >
        <UserAddEdit userData={userInfo} onCancel={handleAfterEditClose} onSave={handleAfterEdit} />
      </AppModal>
    </AppContainer>
  );
}
